<script>
    export let episode;
    export let onBack = () => {};
    export let playAudio = () => {};
    export let pdfUrl = '';
    export let episodeName = '';
</script>

<div class="episode-detail">
    <button class="back-button" on:click={onBack}> ← Zurück zu allen Folgen </button>

    <div class="detail-header">
        {#if episode.featuredImage}
            <img src={episode.featuredImage} alt={episode.name} class="featured-image" />
        {/if}
        <h1>{episode.label || episode.name}</h1>
    </div>

    {#if episode.hasSubEpisodes}
        {#each episode.subEpisodes as subEpisode, idx}
            <div class="sub-episode-section">
                <h3>Folge {idx + 1}</h3>

                <div class="files-container">
                    {#each subEpisode.mp3Files as mp3}
                        <div class="file-item">
                            <button class="play-button" on:click={() => playAudio(mp3.filename, episodeName)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                </svg>
                            </button>
                            <span>{mp3.filename.split('.')[0]}</span>
                        </div>
                    {/each}

                    {#each subEpisode.wavFiles as wav}
                        <div class="file-item">
                            <button class="play-button" on:click={() => playAudio(wav.filename, episodeName)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                </svg>
                            </button>
                            <span>{wav.filename.split('.')[0]}</span>
                        </div>
                    {/each}

                    {#each subEpisode.pdfFiles as pdf}
                        <div class="file-item">
                            <a href={`${pdfUrl}?key=${episodeName}/${pdf.filename}`} download>
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png"
                                    alt="PDF"
                                    width="30"
                                    height="30"
                                />
                                <span>{pdf.filename.replace('.pdf', '').replaceAll('_', ' ')}</span>
                            </a>
                        </div>
                    {/each}
                </div>
            </div>
        {/each}
    {:else}
        <div class="files-container">
            {#each episode.files as file}
                {#if file.filename.endsWith('.pdf')}
                    <div class="file-item">
                        <a href={`${pdfUrl}?key=${episodeName}/${file.filename}`} download>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png"
                                alt="PDF"
                                width="30"
                                height="30"
                            />
                            <span>{file.filename.replace('.pdf', '').replaceAll('_', ' ')}</span>
                        </a>
                    </div>
                {:else if file.filename.endsWith('.mp3') || file.filename.endsWith('.wav')}
                    <div class="file-item">
                        <button class="play-button" on:click={() => playAudio(file.filename, episodeName)}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                        </button>
                        <span>{file.filename.split('.')[0]}</span>
                    </div>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .episode-detail {
        max-width: 900px;
        margin: 0 auto;
        padding: 1rem;
        margin-bottom: 100px;
    }

    .back-button {
        background: none;
        border: none;
        color: #ff3e00;
        font-size: 1rem;
        cursor: pointer;
        padding: 0.5rem 0;
        margin-bottom: 1rem;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
    }

    .back-button:hover {
        text-decoration: underline;
    }

    .detail-header {
        margin-bottom: 2rem;
        text-align: center;
    }

    .featured-image {
        max-width: 600px;
        width: 100%;
        border-radius: 8px;
        margin-bottom: 1rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .detail-header h1 {
        margin: 0;
        color: #333;
    }

    .sub-episode-section {
        margin-bottom: 2rem;
        padding: 1.5rem;
        background: #f9f9f9;
        border-radius: 8px;
    }

    .sub-episode-section h3 {
        margin-top: 0;
        color: #ff3e00;
        border-bottom: 2px solid #ff3e00;
        padding-bottom: 0.5rem;
    }

    .files-container {
        display: grid;
        gap: 1rem;
    }

    .file-item {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 0.5rem;
        border: 1px solid #eee;
        border-radius: 4px;
        background: white;
    }

    .file-item a {
        display: flex;
        align-items: center;
        gap: 1rem;
        text-decoration: none;
        color: inherit;
        width: 100%;
    }

    .file-item span {
        font-size: 0.9rem;
        overflow-wrap: anywhere;
    }

    .play-button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        color: #ff3e00;
        transition: transform 0.2s;
        flex-shrink: 0;
    }

    .play-button:hover {
        transform: scale(1.1);
    }
</style>
